import css from './Home.module.css';

const Home = () => {
  return <div className={css.wrapperHomePage}></div>;
};

export default Home;
